// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `iframe[name=zai-side-chat-iframe] {
  position: fixed;
  top: 0;
  right: 0;
  border: 0;
  z-index: 99999999999;
  display: none;
  width: 580px;
  height: 100%;
}

iframe[name=zai-side-chat-iframe][data-show=true] {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/modules/zai/zai-side-chat-iframe/zai-side-chat-iframe.styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":["iframe[name='zai-side-chat-iframe'] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  border: 0;\n  z-index: 99999999999;\n  display: none;\n  width: 580px;\n  height: 100%;\n}\n\niframe[name='zai-side-chat-iframe'][data-show='true'] {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
